const updateCssVariables = () => {
	const screenHeight = window.innerHeight;
	document.documentElement.style.setProperty('--screen-height', `${screenHeight}px`);
};

updateCssVariables();

window.addEventListener('resize', () => {
	updateCssVariables();
});
